// extracted by mini-css-extract-plugin
export default {"site-subheader":"site-subheader--3wE8f","siteSubheader":"site-subheader--3wE8f"};